/* eslint-disable no-unused-vars */
/* eslint-disable import/first */

import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
Vue.use(VueResource)

import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad, {
  preLoad: 1,
  // error: require('./assets/img/bgimages/ppt.png'),
  // loading: require('./assets/img/bgimages/ppt.png'),
  attempt: 2
})

import Toast from './toast.js' // 为了引用tip组件
Vue.use(Toast)

import $ from 'jquery'

// @4.6.1
// import 'bootstrap'
// // import '@/static/js/bootstrap.min.js'   // 报错
// // import '@/static/css/bootstrap.min.css'
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap/dist/js/bootstrap.min.js'
// import 'bootstrap/dist/js/bootstrap.js'

// @2.22.0
// import BootstrapVue from 'bootstrap-vue'
// Vue.use(BootstrapVue)

import wx from 'weixin-js-sdk' // 引入微信jssdk
Vue.use(wx)

import global from './Global.vue' // 设置全局变量
Vue.prototype.global = global

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
// import "@/common/js/imgscroll.min.js"

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

import {
  Button,
  Input,
  Tabs,
  Pagination,
  Rate,
  Select
} from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
Vue.use(Button)
Vue.use(Input)
Vue.use(Tabs)
Vue.use(Pagination)
Vue.use(Rate)
Vue.use(Select)

Vue.config.productionTip = false

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   render: h => h(App)
// })
export function createApp () {
  const app = new Vue({
    el: '#app',
    router,
    render: h => h(App)
  })
  return { app, router }
}

if (typeof window !== 'undefined') {
  const { app } = createApp()
}

// 检测浏览器是否为IE8
var DEFAULT_VERSION = 8.0
var ua = navigator.userAgent.toLowerCase()
var isIE = ua.indexOf('msie') > -1
var safariVersion
if (isIE) {
  safariVersion = ua.match(/msie ([\d.]+)/)[1]
}
if (safariVersion <= DEFAULT_VERSION) {
  alert('系统检测到您正在使用ie8以下内核的浏览器，不能实现完美体验，请更换或升级浏览器访问！')
};

// js文件 s95.cnzz.com
// var cnzz_protocol = (("https:" == document.location.protocol) ? "https://" : "http://");
// document.write(unescape("%3Cspan id='cnzz_stat_icon_3614275'%3E%3C/span%3E%3Cscript src='" + cnzz_protocol + "s95.cnzz.com/stat.php%3Fid%3D3614275' type='text/javascript'%3E%3C/script%3E"));
// // document.write(unescape("%3Cscript type%3D%22text/javascript%22 charset%3D%22utf-8%22 src%3D%22src/common/js/imgscroll.min.js%22%3E %3C/script%3E"));

// 清缓存
const VUE_APP_VERSION = require('../package.json').version
const vers = window.localStorage.getItem('mpd-version') || ''
if (VUE_APP_VERSION.toString() !== vers.toString()) {
  localStorage.clear()
  window.localStorage.setItem('mpd-version', VUE_APP_VERSION)
  location.reload()
}
console.log('v', VUE_APP_VERSION)



// WEBPACK FOOTER //
// ./src/main.js